'use client';

import LibraryPage from './library/page';

export default function HomePage() {
  return <LibraryPage />;
}
